import axios from "axios";

const endpoint_url = "/message/whatsappTemplate/update";

const updateWhatsappTemplate = ({
  message_uuid,
  whatsapp_template_uuid,
  name,
  data
}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, {
        whatsapp_template_uuid,
        message_uuid,
        name,
        data
      })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default updateWhatsappTemplate;
